import type { BodyStoryblok } from "@/types/storyblok-blok-types";

import UI from "./UI";

const Body = ({ blok }: { blok: BodyStoryblok; preview: boolean }) => {
  return <UI blok={blok} />;
};

export default Body;
